'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _TailSpin = require('./TailSpin');

var _TailSpin2 = _interopRequireDefault(_TailSpin);

var _ErrorCross = require('./ErrorCross');

var _ErrorCross2 = _interopRequireDefault(_ErrorCross);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$LoadingIndicator = _ref.LoadingIndicator,
      LoadingIndicator = _ref$LoadingIndicator === undefined ? _TailSpin2.default : _ref$LoadingIndicator,
      _ref$ErrorIndicator = _ref.ErrorIndicator,
      ErrorIndicator = _ref$ErrorIndicator === undefined ? _ErrorCross2.default : _ref$ErrorIndicator,
      rest = _objectWithoutProperties(_ref, ['LoadingIndicator', 'ErrorIndicator']);

  return (0, _core2.default)(_extends({}, rest, { LoadingIndicator: LoadingIndicator, ErrorIndicator: ErrorIndicator }));
};